import React, { useEffect, useState } from 'react';
import { Card } from '../../components/common';
import { useAuth } from '../../context/AuthContext';
import { settingService } from '../../services/resources';

export default function DashboardPage() {
  const { user } = useAuth();
  const [storeName, setStoreName] = useState('');

  // Best-effort store name (ignored if the user lacks Settings permission).
  useEffect(() => {
    settingService
      .get()
      .then((d) => setStoreName(d.StoreName || ''))
      .catch(() => {});
  }, []);

  return (
    <div className="space-y-6">
      <Card>
        <h1 className="text-xl font-semibold text-gray-800">
          Welcome{user?.username ? `, ${user.username}` : ''} 👋
        </h1>
        <p className="mt-1 text-sm text-gray-500">
          {storeName ? storeName : 'Money Changer Management System'}
        </p>
      </Card>

      {/* Placeholder widget slots — populated once Phase 2+ data exists. */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {["Today's Transactions", 'Bank Balances', 'Cash Position'].map((t) => (
          <Card key={t} title={t}>
            <div className="flex h-24 items-center justify-center text-sm text-gray-400">
              Coming soon
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
